<template>
    <div>
        <b-button
            variant="primary"
            @click.stop="selecionarTodos()"
            v-if="mostrarBtn"
            >Selecionar Todos</b-button
        >
    </div>
</template>

<script>
export default {
    props: {
        itensRequisicao: {
            type: Array
        }
    },

    data() {
        return {}
    },

    methods: {
        selecionarTodos() {
            for (let index = 0; index < this.itensRequisicao.length; index++) {
                const element = this.itensRequisicao[index]
                let itemDto = {
                    idItemRequisicao: element.idItemRequisicao,
                    valorRateado: element.saldoASerRateado
                }
                this.$emit('selecionarItem', itemDto)
            }
        }
    },

    computed: {
        mostrarBtn() {
            let seqsRmTemp = this.itensRequisicao.map((i) => i.seqRm)
            let seqsRm = [...new Set(seqsRmTemp)]
            if (seqsRm) {
                return seqsRm.length == 1
            }
            return false
        }
    }
}
</script>
